/**
 * Does a friend match what was typed into a friend picker? By name or by
 * their public handle — never by email: the friends list carries none (C322,
 * Kurtis 2026-10-16: an adult's email is theirs, not their friends'). A
 * leading "@" is the handle's, so "@ana" and "ana" find the same person.
 *
 * @param {{ name?: string, handle?: string }} friend
 * @param {string} query - the search box's text
 * @returns {boolean} true for an empty query
 */
export function friendMatchesQuery(friend, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  const name = (friend?.name || '').toLowerCase();
  if (name.includes(q)) return true;
  const handleQuery = q.replace(/^@+/, '');
  const handle = (friend?.handle || '').toLowerCase();
  return !!handleQuery && !!handle && handle.includes(handleQuery);
}

export default friendMatchesQuery;
